import { render, staticRenderFns } from "./ContractorRegionView.vue?vue&type=template&id=12606992"
import script from "./ContractorRegionView.vue?vue&type=script&lang=js"
export * from "./ContractorRegionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports